export default __webpack_public_path__ + "static/media/vodafone-extra-bold.2e53f51b.woff";